import axios from "axios";
import { redirect, useLoaderData } from "react-router-dom";
import http from "../../http";

export default function Auth() {
    const data = useLoaderData() as any;
    if (data.success) {
        // Simulate an HTTP redirect:
        window.location.replace(`${data.result.redirect}?code=${data.result.code}${data.result.state ? `&state=${data.result.state}` : ''}`);
    }
    return (
        <div></div>
    )
}

interface loader {
    request: Request;
    params: {};
}

export async function authLoader(data: loader) {
    const url = new URL(data.request.url);
    if (!localStorage.getItem(process.env.REACT_APP_TOKEN_NAME ?? 'token')) {
        const lastLogin = Number(localStorage.getItem("lastLogin") ?? '0');
        if (new Date().getTime() - lastLogin > 120000) {
            localStorage.setItem('lastLogin', new Date().getTime().toString())
            return redirect(`/login?${url.searchParams.toString()}`);
        } else {
            localStorage.removeItem('lastLogin');
            window.location.replace(`${url.searchParams.get('redirect_uri')}?error=access_denied&error_description=The+user+denied+the+request
                    ${url.searchParams.get('state') ? `&state=${url.searchParams.get('state')}` : ''}`);
        }
    }
    const responseType = url.searchParams.get('response_type');
    const clientId = url.searchParams.get('client_id');
    const scope = url.searchParams.get('scope');
    const state = url.searchParams.get('state');
    const redirectUri = url.searchParams.get('redirect_uri');
    try {
        const res = await http({
            url: 'auth',
            method: 'post',
            data: {
                responseType,
                clientId,
                scope,
                state,
                redirectUri,
            }
        })
        return res.data;
    } catch (error: any) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME ?? 'token')
            return redirect(`/login?${url.searchParams.toString()}`);
        }
        throw error;
    }
}
